import { render, staticRenderFns } from "./GestionAdendas.vue?vue&type=template&id=49b8fd4f&scoped=true"
import script from "./GestionAdendas.vue?vue&type=script&lang=js"
export * from "./GestionAdendas.vue?vue&type=script&lang=js"
import style0 from "./GestionAdendas.vue?vue&type=style&index=0&id=49b8fd4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b8fd4f",
  null
  
)

export default component.exports